module.exports = __webpack_public_path__ + "images/bottom.35a3352a1c154e1123ee8f589ac8f501.png";